/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-component-legacy/upgraded-url/template/urlTestTool.pug';
import ViewModel from '@bingads-webui-component-legacy/upgraded-url/viewmodel/urlTestTool';
import * as Popup from '@bingads-webui-component-legacy/popup/view/index';
import urlTestToolStatusTemplate from '@bingads-webui-component-legacy/upgraded-url/template/urlTestToolStatus.pug';
import urlTestResultTemplate from '@bingads-webui-component-legacy/upgraded-url/template/urlTestResult.pug';
import urlTestResultSummaryTemplateV2 from '@bingads-webui-component-legacy/upgraded-url/template/urlTestResultSummaryV2.pug';
import urlTestResultListSummaryTemplateV2 from '@bingads-webui-component-legacy/upgraded-url/template/urlTestResultListSummaryV2.pug';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var ResultTypes = ['UURLTestTool_Result_Found', 'UURLTestTool_Result_NotFound', 'UURLTestTool_Result_Mismatch', 'UURLTestTool_Result_Unreachable', 'UURLTestTool_Result_Unknown', 'UURLTestTool_Result_UserInputError', 'UURLTestTool_Result_NoEligibleUrlsFound', 'UURLTestTool_Result_TestComplete'];
var TrackingResultTypes = ['UURLTestTool_TrackingCall_Successful', 'UURLTestTool_TrackingCall_Unsuccessful'];
var LevelTypes = ['Unkown', 'Entity_Account', 'Entity_Campaign', 'Entity_Adgroup', 'Entity_Ads', 'Entity_Keywords', 'Entity_SitelinkExtensions'];
var TestingItemMapping = {
  ptLandingUrl: 'ptLandingUrl',
  ptTrackingUrl: 'ptTrackingUrl',
  sqServingUrl: 'sqServingUrl'
};
function getLevelString(level) {
  return level === 0 ? null : i18n.getString('UURLTestTool_From', i18n.get(LevelTypes[level]));
}
function normalizeUurlTestResult(rawResult) {
  if (_.isUndefined(rawResult)) {
    return rawResult;
  }
  var attributes = _.union(_.map(rawResult.CustomParameters, function (parameter) {
    return {
      Key: '{_' + parameter.Key + '}',
      Value: parameter.Value,
      Level: getLevelString(parameter.Level)
    };
  }), _.map(rawResult.ValueTrackParameters, function (parameter) {
    return {
      Key: '{' + parameter.Key + '}',
      Value: parameter.Value,
      Level: null
    };
  }), _.map(rawResult.IndicateParameters, function (parameter) {
    return {
      Key: parameter.Key,
      Value: parameter.Value,
      Level: null
    };
  }));
  if (rawResult.LpUrl) {
    attributes = _.union([{
      Key: '{' + rawResult.LpUrl.Key + '}',
      Value: rawResult.LpUrl.Value,
      Level: getLevelString(rawResult.LpUrl.Level)
    }], attributes);
  }
  var result = {
    resultType: rawResult.Result,
    resultString: i18n.get(ResultTypes[rawResult.Result]),
    servingUrl: rawResult.ServingUrl,
    landingUrl: rawResult.LandingUrl,
    attributes: attributes
  };
  if (rawResult.TrackingTemplate) {
    var trackingTemplate = {
      Value: rawResult.TrackingTemplate.Value,
      Level: getLevelString(rawResult.TrackingTemplate.Level)
    };
    result = _.extend(result, {
      trackingTemplate: trackingTemplate
    });
  }
  if (rawResult.FinalUrl) {
    var finalUrl = {
      Value: rawResult.FinalUrl.Value,
      Level: getLevelString(rawResult.FinalUrl.Level)
    };
    result = _.extend(result, {
      finalUrl: finalUrl
    });
  }
  if (rawResult.FinalUrlSuffix) {
    var finalUrlSuffix = {
      Value: rawResult.FinalUrlSuffix.Value,
      Level: getLevelString(rawResult.FinalUrlSuffix.Level)
    };
    result = _.extend(result, {
      finalUrlSuffix: finalUrlSuffix
    });
  }
  if (rawResult.ParallelTrackingUrl) {
    var trackingUrl = {
      Value: rawResult.ParallelTrackingUrl.Value,
      Level: getLevelString(rawResult.ParallelTrackingUrl.Level)
    };
    result = _.extend(result, {
      trackingUrl: trackingUrl
    });
  }
  if (!_.isNull(rawResult.TrackingCallResult) && !_.isUndefined(rawResult.TrackingCallResult)) {
    result = _.extend(result, {
      trackingResultType: rawResult.TrackingCallResult,
      trackingResultString: i18n.get(TrackingResultTypes[rawResult.TrackingCallResult])
    });
  }
  return result;
}
var detailPopup = null;
var UrlTestTool = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    _.defaults(this.options, {
      template: tmpl,
      location: 'topRight',
      position: Popup.PositionAttribute.fixed
    });
    this.ko_model = new ViewModel();
  },
  events: {
    'click .testUurl': 'testUurl',
    'click .resultDetails': 'showResultV2',
    'click .resultString': 'showResultDetailsForVNext',
    'mouseover .resultString': 'showResultDetailsForVNext'
  },
  attributes: function () {
    return {
      'class': this.options.urlTestToolStatusContainer ? 'uurl-test-tool-inline' : ''
    };
  },
  render: function () {
    var useDefaultStatusContainer = !this.options.urlTestToolStatusContainer;
    var self = this;
    var popupSelector = '.popup--uurl-v2-' + this.cid;
    this.$el.html($(tmpl({
      i18n: i18n,
      useDefaultStatusContainer: useDefaultStatusContainer
    })));
    ko.cleanNode($(this.$('input.testUurl'))[0]);
    ko.applyBindings(this.ko_model, $(this.$('input.testUurl'))[0]);
    var urlTestToolStatusContainer = this.options.urlTestToolStatusContainer || this.$('.uurl-test-info__container');
    urlTestToolStatusContainer.empty().append($(urlTestToolStatusTemplate({
      i18n: i18n,
      isForVNext: true
    })));
    ko.cleanNode(urlTestToolStatusContainer[0]);
    ko.applyBindings(this.ko_model, urlTestToolStatusContainer[0]);
    if (!useDefaultStatusContainer) {
      urlTestToolStatusContainer.on('click', '.resultDetails', this.showResultV2.bind(this));
      urlTestToolStatusContainer.on('mouseover', '.resultString', this.showResultDetailsForVNext.bind(this));
    }
    $('body').off('click', '.popup--uurl-v2').on('click', '.popup--uurl-v2', function (e) {
      var $target = $(e.target);
      if (!$target.hasClass('HelpTopic')) {
        e.stopPropagation();
      }
      if ($target.closest('.popup--uurl-detail').length === 0) {
        self.dismissDetailPopup();
      }
    });
    $('body').off('click', '.popup--uurl-v2 [data-toggle="collapse"]').on('click', '.popup--uurl-v2 [data-toggle="collapse"]', function (e) {
      var curr = $(e.target);
      var parent = curr.parent(curr.attr('data-target'));
      var hasIn = parent.hasClass('in');
      var target = $('[aria-expanded="' + !hasIn + '"]' + curr.attr('data-target'));
      parent.toggleClass('in').attr('aria-expanded', !hasIn).height(hasIn ? '0' : 'auto');
      target.toggleClass('in').attr('aria-expanded', hasIn).height(!hasIn ? '0' : 'auto');
    });
    $('body').off('click', popupSelector + ' .ptLandingUrl').on('click', popupSelector + ' .ptLandingUrl', function (e) {
      self.showResultUrlDetailV2(e, TestingItemMapping.ptLandingUrl);
      e.stopPropagation();
    });
    $('body').off('click', popupSelector + ' .ptTrackingUrl').on('click', popupSelector + ' .ptTrackingUrl', function (e) {
      self.showResultUrlDetailV2(e, TestingItemMapping.ptTrackingUrl);
      e.stopPropagation();
    });
    $('body').off('click', popupSelector + ' .sqServingUrl').on('click', popupSelector + ' .sqServingUrl', function (e) {
      self.showResultUrlDetailV2(e, TestingItemMapping.sqServingUrl);
      e.stopPropagation();
    });
    return this;
  },
  remove: function () {
    ko.cleanNode(this.el);
    return this;
  },
  fetchAccountFinalUrlSuffix: function () {
    var select = '$select=FinalUrlSuffix';
    var url = 'Customers(' + window.App.state.get('advertisercustomer_id') + ')/Accounts(' + window.App.state.get('account_id') + ')?' + select;
    return odata.get(url).then(function (response) {
      return response.FinalUrlSuffix;
    });
  },
  testUurl: function () {
    var self = this;
    this.fetchAccountFinalUrlSuffix().then((function (res) {
      this.ko_model.showTesting(true);
      this.ko_model.resultString(null);
      this.ko_model.resultType(null);
      this.trigger('testUurl', self.handleTestResultList, _.extend(self, {
        isParallelTracking: true,
        accountFinalUrlSuffix: res
      }));
    }).bind(this));
  },
  getTestStatus: function () {
    return {
      resultType: this.ko_model.resultType(),
      resultString: this.ko_model.resultString(),
      showTesting: this.ko_model.showTesting()
    };
  },
  handleTestResultList: function (rawResultList) {
    this.ko_model.showTesting(false);
    if (!rawResultList) {
      return;
    }
    if (rawResultList.Result && rawResultList.Errors && rawResultList.Errors.length) {
      this.ko_model.resultType(rawResultList.Result);
      this.ko_model.resultString(i18n.get(ResultTypes[rawResultList.Result]));
      return;
    }
    if (!_.isArray(rawResultList) || !rawResultList.length) {
      return;
    }
    this.urlTestResultList = [];
    this.isMultipleResult = rawResultList.isMultipleResult;
    this.resultListTrackingTemplate = rawResultList.resultListTrackingTemplate;
    var self = this;
    _.each(rawResultList, function (rawResult) {
      if (!rawResult) {
        return;
      }
      var normalizedResult = {
        sequentialTrackingResult: normalizeUurlTestResult(_.extend({}, {
          Result: rawResultList.Result
        }, rawResult.SequentialTrackingResult)),
        parallelTrackingResult: rawResult.ParallelTrackingResult ? normalizeUurlTestResult(_.extend({}, {
          Result: rawResultList.Result
        }, rawResult.ParallelTrackingResult)) : null,
        campaignName: rawResult.CampaignName,
        adGroupName: rawResult.AdGroupName
      };
      if (!self.ko_model.resultType()) {
        self.calculateResultType(normalizedResult);
      }
      self.urlTestResultList.push(normalizedResult);
    });
    if (rawResultList.Result === 7) {
      this.ko_model.resultString(i18n.getString(ResultTypes[rawResultList.Result]));
    }
  },
  calculateResultType: function (urlTestResult) {
    var sequentialTrackingResult = urlTestResult.sequentialTrackingResult;
    var parallelTrackingResult = urlTestResult.parallelTrackingResult;
    var isParallelTracking = !!parallelTrackingResult;
    if (isParallelTracking && parallelTrackingResult.resultType !== 0) {
      this.ko_model.resultType(parallelTrackingResult.resultType);
      this.ko_model.resultString(parallelTrackingResult.resultString);
    } else if (isParallelTracking && parallelTrackingResult.trackingResultType !== 0) {
      this.ko_model.resultType(parallelTrackingResult.trackingResultType);
      this.ko_model.resultString(parallelTrackingResult.trackingResultString);
    } else {
      this.ko_model.resultType(sequentialTrackingResult.resultType);
      this.ko_model.resultString(sequentialTrackingResult.resultString);
    }
  },
  createResultItemV2: function (result) {
    var sq = result.sequentialTrackingResult || ({});
    var pt = result.parallelTrackingResult || ({});
    var item = {
      sq: {
        resultType: sq.resultType,
        resultString: sq.resultString,
        landingUrl: sq.landingUrl,
        servingUrl: sq.servingUrl,
        finalUrl: sq.finalUrl,
        attributes: sq.attributes,
        trackingTemplate: sq.trackingTemplate,
        finalUrlSuffix: sq.finalUrlSuffix
      },
      pt: {
        resultType: pt.resultType,
        resultString: pt.resultString,
        landingUrl: pt.landingUrl,
        servingUrl: pt.servingUrl,
        finalUrl: pt.finalUrl,
        attributes: pt.attributes,
        trackingTemplate: pt.trackingTemplate,
        finalUrlSuffix: pt.finalUrlSuffix,
        trackingUrl: pt.trackingUrl,
        trackingResultType: pt.trackingResultType,
        trackingResultString: pt.trackingResultString
      },
      campaignName: result.campaignName,
      adGroupName: result.adGroupName || i18n.getString('UURLTestTool_NA')
    };
    return item;
  },
  showResultV2: function (event) {
    if (this.isMultipleResult) {
      this.showResultListV2(event);
    } else {
      this.showResultSingleV2(event);
    }
  },
  showResultSingleV2: function (event) {
    if (!this.urlTestResultList || !this.urlTestResultList.length) {
      return;
    }
    var result = this.createResultItemV2(this.urlTestResultList[0]);
    Popup.show(_.extend({}, {
      positioningMethod: 'fixed',
      positioningOptions: {
        location: this.options.location,
        positionAttribute: this.options.position
      },
      classes: ['popup--uurl-v2', 'popup--uurl-v2-' + this.cid],
      template: function () {
        return urlTestResultSummaryTemplateV2({
          sq: result.sq,
          pt: result.pt,
          i18n: i18n
        });
      }
    }, {
      container: $('body'),
      anchor: $(event.target)
    }));
  },
  showResultListV2: function (event) {
    var resultList = [];
    _.each(this.urlTestResultList, (function (result) {
      resultList.push(this.createResultItemV2(result));
    }).bind(this));
    Popup.show(_.extend({}, {
      positioningMethod: 'fixed',
      positioningOptions: {
        location: this.options.location,
        positionAttribute: this.options.position
      },
      classes: ['popup--uurl-v2', 'popup--uurl-v2-' + this.cid],
      template: (function () {
        return urlTestResultListSummaryTemplateV2({
          resultList: resultList,
          resultListTrackingTemplate: this.resultListTrackingTemplate,
          i18n: i18n
        });
      }).bind(this)
    }, {
      container: $('body'),
      anchor: $(event.target)
    }));
  },
  showResultDetailsForVNext: function (event) {
    this.showResultV2(event);
  },
  showResultUrlDetailV2: function (event, testingItem) {
    var index = $(event.target).data('index') || 0;
    var result = this.urlTestResultList[index];
    if (!result) {
      return;
    }
    var sq = result.sequentialTrackingResult;
    var pt = result.parallelTrackingResult;
    var trackingResult = testingItem === TestingItemMapping.sqServingUrl ? sq : pt;
    var finalUrl = trackingResult.finalUrl;
    var trackingTemplate = trackingResult.trackingTemplate;
    var finalUrlSuffix = trackingResult.finalUrlSuffix;
    var attributes = trackingResult.attributes;
    this.dismissDetailPopup();
    detailPopup = new Popup.Popup();
    detailPopup.show(_.extend({}, {
      positioningMethod: 'fixed',
      positioningOptions: {
        location: this.calculateDetailPopupLocation($(event.target))
      },
      classes: ['popup--uurl-detail'],
      template: function () {
        return urlTestResultTemplate({
          finalUrl: finalUrl,
          attributes: attributes,
          trackingTemplate: trackingTemplate,
          finalUrlSuffix: finalUrlSuffix,
          i18n: i18n,
          index: 0
        });
      }
    }, {
      container: $('.popup.popup--uurl-v2'),
      anchor: $(event.target)
    }));
  },
  calculateDetailPopupLocation: function (anchor) {
    var windowHeight = $(window).height();
    var anchorTop = anchor[0].getBoundingClientRect().top;
    var anchorHeight = anchor.outerHeight();
    if (windowHeight - anchorHeight - anchorTop > 400) {
      return 'buttomRight';
    }
    return 'topRight';
  },
  dismissDetailPopup: function () {
    if (detailPopup) {
      detailPopup.dismiss();
      detailPopup = null;
    }
  }
});
export default UrlTestTool;

